import styled from 'styled-components'

import { MediaStyled } from '@ui/elements/Media/styles/MediaStyled'

interface IFileViewerFileListItemStyledProps {
  isActive: boolean
}

export const FileViewerFileListItemStyled = styled.div<IFileViewerFileListItemStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
  cursor: pointer;

  ${MediaStyled} {
    ${(props) =>
      props.isActive && `box-shadow: 0 0 2px 2px ${props.theme.colors.primary}`}
  }
`
